import React from 'react';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import IconButton from '@mui/material/IconButton';

export default function CommentSearchBar({ value, onChange, sx = {} }) {
  return (
    <FormControl sx={{ width: { xs: '100%', md: '25ch' }, ...sx }} variant="outlined">
      <OutlinedInput
        size="small"
        id="comment-search"
        placeholder="Search comments…"
        value={value}
        onChange={onChange}
        startAdornment={
          <InputAdornment position="start" sx={{ color: 'text.primary' }}>
            <SearchRoundedIcon fontSize="small" color="success" />
          </InputAdornment>
        }
        endAdornment={
          value ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label="clear"
                onClick={() => onChange({ target: { value: '' } })}
                sx={{
                  p: 0,
                  width: '1.5rem',
                  height: '1.5rem',
                  border: 0,
                  bgcolor: 'transparent',
                  '&:hover': { bgcolor: 'transparent' },
                  '&:active': { bgcolor: 'transparent' },
                }}
              >
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
        inputProps={{ 'aria-label': 'search comments' }}
      />
    </FormControl>
  );
}
